import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ExternalClass, ExternalClassDepartment, ExternalSchoolLevel, ExternalSchoolUnit} from '../../../models/externalSchoolInfo';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {SaveQueryDialogComponent} from './save-query-dialog/save-query-dialog.component';

@Component({
  selector: 'app-search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.scss']
})
export class SearchDialogComponent implements OnInit {
  criteria = [];
  displayQuery = 'where';
  fields;
  mustDisable: boolean;
  loadingStoredQueries = false;
  query;
  queryFields = [];
  section: string;
  selectedField;
  selectedQueryType: any;
  selectedQueryValue: any;
  storedQueries: any;
  externalSchoolUnits: ExternalSchoolUnit[] = [];
  externalSchoolLevels: ExternalSchoolLevel[] = [];
  externalClasses: ExternalClass[] = [];
  externalClassDepartments: ExternalClassDepartment[] = [];
  textSearchTypes = [{id: 0, label: 'Αρχίζει', type: 'startsWith'}, {id: 1, label: 'Τελειώνει', type: 'endsWith'},
    {id: 2, label: 'Ίσο', type: 'equal'}, {id: 3, label: 'Περιέχει', type: 'equal'},
    {id: 4, label: 'Διάφορο', type: 'not'}];

  constructor(public dialogRef: MatDialogRef<SearchDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private commonService: CommonService, public dialog: MatDialog, public toastMessagesService: ToastMessagesService) {
    this.fields = data.searchFields;
    this.section = data.section;
    if (this.section === 'students') {
      this.externalSchoolUnits = data.externalSchoolUnits;
      this.externalSchoolLevels = data.externalSchoolLevels;
      this.externalClasses = data.externalClasses;
      this.externalClassDepartments = data.externalClassDepartments;
    }

    this.mustDisable = false;
  }

  async ngOnInit() {
    const textFields = this.fields.filter(field => field.type === 'text');
    await this.loadQueries();
    this.loadLastSearch();
  }

  loadLastSearch() {
    const lastSearchJson = localStorage.getItem('lastSearch');
    if (lastSearchJson) {
      const lastSearch: any = JSON.parse(lastSearchJson);
      if (lastSearch.section === this.section) {
        this.criteria = [];
        this.criteria = lastSearch.criteria;

        for (const searchCriteria of this.criteria) {
          const fieldsIndex = this.fields.findIndex(field => field.field === searchCriteria.selectedField.field);
          searchCriteria.selectedField = this.fields[fieldsIndex];

          const searchTypeIndex = this.textSearchTypes.findIndex(c => c.id === searchCriteria.selectedQueryType.id);
          searchCriteria.selectedQueryType = this.textSearchTypes[searchTypeIndex];
        }

        this.displayQuery = 'where ';
        this.formatQuery();
        // console.log(lastSearch.criteria);
        // this.criteria.unshift(...lastSearch.criteria);
        //
        // this.displayQuery = 'where ';
        // this.formatQuery();
      }
    }

  }

  async loadQueries() {
    this.loadingStoredQueries = true;
    try {
      const queriesObject = await this.commonService.getList(`common/query?section=${this.section}`);
      this.storedQueries = queriesObject.object;
      for (const storedQuery of this.storedQueries) {
        storedQuery.clause = this.fromBase64(storedQuery.clause);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingStoredQueries = false;
    }
  }
  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    }));
  }
  async storeQuery() {
    const isValid = this.validateQuery();

    if (isValid) {
      const save = this.dialog.open(SaveQueryDialogComponent, {});
      save.afterClosed().subscribe(async (title) => {
        if (title) {
          const model = {
            title,
            clause: this.b64EncodeUnicode(this.displayQuery),
            ui_content: JSON.stringify(this.criteria),
            section: this.section
          };
          try {
            await this.commonService.insertItem(`common/query`, model);
            this.toastMessagesService.toastMessages(`Η αποθήκευση ολοκληρώθηκε με επιτυχία`);
            await this.loadQueries();
          } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
          }
        }
      });
    } else {
      this.toastMessagesService.toastErrorMessage('Παρακαλούμε ελέγξτε τα στοιχεία της αναζήτησής σας είναι όλα συμπληρωμένα');
    }
  }

  validateQuery(): boolean {
    let count = 0;
    let isValid = true;
    for (const searchCriteria of this.criteria) {
      if (count > 0) {
        if (!searchCriteria.junction) {
          isValid = false;
          break;
        }
      }
      count++;
    }
    return isValid;
  }

  search() {
    const lastSearch = {
      query: this.displayQuery,
      criteria: this.criteria,
      section: this.section,
    };
    localStorage.setItem('lastSearch', JSON.stringify(lastSearch));
    const isValid = this.validateQuery();
    if (isValid) {
      this.close(this.displayQuery);
    } else {
      this.toastMessagesService.toastErrorMessage(`Συμληρώστε όλα τα συνδετικά ΚΑΙ / Η`);
    }
  }

  close(query?: string) {
    this.dialogRef.close(this.criteria.length > 0 ? query : null);
  }

  formQuery() {
    const model = {
      junction: '',
      selectedField: this.selectedField,
      selectedQueryType: this.selectedQueryType,
      selectedQueryValue: this.selectedField.type === 'text' ? this.selectedQueryValue : this.selectedField.value.description,
      customObject: this.selectedField.value
    };
    if (this.selectedField.field === 'college_department_id') {
      model.selectedQueryValue = this.selectedField.type === 'text' ? this.selectedQueryValue : this.selectedField.value.displayDescription;
    }

    if (model.selectedQueryValue && model.selectedQueryType && model.selectedQueryValue) {
      this.criteria.push(model);

      this.selectedQueryValue = '';
      this.selectedField = null;
      this.selectedQueryType = null;
      this.mustDisable = false;
      this.displayQuery = 'where ';
      this.formatQuery();
    } else {
      this.toastMessagesService.toastMessages(`Πρέπει να συμπληρώσετε τα ολα τα πεδία`);
    }
  }

  reFormQuery() {
    this.displayQuery = 'where ';
    this.formatQuery();
  }

  addToQuery(junction, condition) {
    this.displayQuery += ` ${junction} (${condition})`;
  }

  formatQuery() {
    for (const criteria of this.criteria) {
      let condition = '';
      switch (criteria.selectedQueryType.id) {
        case 0:
          condition = `LIKE '${criteria.selectedQueryValue}%'`;
          break;
        case 1:
          condition = `LIKE '%${criteria.selectedQueryValue}'`;
          break;
        case 2:
          let key = '';
          if (criteria.selectedField.type === 'select') {
             if (criteria.selectedField.field === 'college_school_id') {
               key = 'college_school_unit_id';
             } else if (criteria.selectedField.field === 'college_school_level') {
               key = 'college_school_id';
             } else {
               key = criteria.selectedField.field;
             }
           }
          condition = criteria.selectedField.type === 'select' ? `='${criteria.customObject[key]}'` : `= '${criteria.selectedQueryValue}'`;
          break;
        case 3:
          condition = `LIKE '%${criteria.selectedQueryValue}%'`;
          break;
        case 4:
          condition = `<> '${criteria.selectedQueryValue}'`;
          break;
      }
      this.addToQuery(`${criteria.junction}`, `${criteria.selectedField.field} ${condition}`);
    }
  }

  alterJunction(searchCriteria: any, type: number) {
    this.displayQuery = 'where ';
    searchCriteria.junction = type === 0 ? 'AND' : 'OR';
    this.formatQuery();
  }

  toBase64(value: string) {
    return btoa(value);
  }

  fromBase64(value: string): string {
    return atob(value);
  }

  deleteCriteria(searchCriteria: any) {
    const index = this.criteria.indexOf(searchCriteria);

    this.criteria.splice(index, 1);
    this.displayQuery = 'where ';
    this.formatQuery();
  }

  renderSelectedQuery(storedQuery: any) {
    this.criteria = [];
    this.criteria = JSON.parse(storedQuery.ui_content);

    for (const searchCriteria of this.criteria) {
      const fieldsIndex = this.fields.findIndex(field => field.field === searchCriteria.selectedField.field);
      searchCriteria.selectedField = this.fields[fieldsIndex];

      const searchTypeIndex = this.textSearchTypes.findIndex(c => c.id === searchCriteria.selectedQueryType.id);
      searchCriteria.selectedQueryType = this.textSearchTypes[searchTypeIndex];
    }

    this.displayQuery = 'where ';
    this.formatQuery();
  }

  updateStoredCriteria(storedQuery: any) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να ενημερώσετε το κριτήριο με τίτλο ${storedQuery.title}`,
        title: `Ενημέρωση αποθηκευμένου κριτηρίου`,
        icon: 'update',
        iconColor: 'blue'
      }
    });
    confirmDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const model = {
            clause: this.b64EncodeUnicode(this.displayQuery),
            ui_content: JSON.stringify(this.criteria),
          };
          await this.commonService.updateItem(`common/query?id=${storedQuery.id}`, model);
          this.toastMessagesService.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
          await this.loadQueries();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  deleteStoredCriteria(storedQuery: any) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε το κριτήριο με τίτλο ${storedQuery.title}`,
        title: `Διαγραφή αποθηκευμένου κριτηρίου`,
        icon: 'delete',
        iconColor: 'red'
      }
    });
    confirmDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.deleteItem(`common/query?id=${storedQuery.id}`);
          this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
          await this.loadQueries();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  searchCriteriaChanged() {
    this.mustDisable = this.selectedField.type === 'select';
    if (this.selectedField.type === 'select') {
      this.selectedQueryType = this.textSearchTypes[2];
    }
  }

  getSelectedValueOptions() {
    let items = [];
    if (this.selectedField) {
      switch (this.selectedField.field) {
        case 'college_school_id':
          items = this.externalSchoolUnits;
          break;
        case 'college_school_level':
          items = this.externalSchoolLevels;
          break;
        case 'college_class_id':
          items = this.externalClasses;
          break;
        case 'college_department_id':
          items = this.externalClassDepartments;
          break;
      }
    }

    return items;
  }

  displayOptionValue(item: any) {
    let display = '';
    switch (this.selectedField.field) {
      case 'college_school_id':
        display = item.description;
        break;
      case 'college_school_level':
        display = `${item.description} (${item.school_description})`;
        break;
      case 'college_class_id':
        display = `${item.description} (${item.school_unit_description} - ${item.school_level_description})`;
        break;
      case 'college_department_id':
        display = `${item.displayDescription}`;
        break;

    }
    return display;
  }
}
